import React from 'react'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import CmsContentTitle from 'redesign/components/molecules/cms-content-title'
import CmsContentFooter from 'redesign/components/organisms/cms-content-footer/cms-content-footer'
import type { Block } from 'shared/graphql/graphql'
import BlockComponent from '../cms-block/cms-block'
import { Container } from './styles'
import type { CmsContentViewProps } from './types'
import useCmsContentView from './use-cms-content-view'

const CmsContentView: React.FC<CmsContentViewProps> = ({ content, blocks = [], loading = false }) => {
  const { createdHistory, updatedHistory, metadata, audiences, restrictAbsenceComment, isAbsenceRestricted } =
    useCmsContentView(content)

  if (loading) return <LoadingSpinner />

  return (
    <Container>
      <CmsContentTitle
        title={metadata?.title}
        restrictAbsenceComment={restrictAbsenceComment}
        isAbsenceRestricted={isAbsenceRestricted}
        content={content}
      />
      {blocks.map((block: Block) => (
        <BlockComponent key={block.order} block={block} />
      ))}
      <CmsContentFooter createdHistory={createdHistory} updatedHistory={updatedHistory} audiences={audiences} />
    </Container>
  )
}

export default CmsContentView
